import header from './header.css'
import {FaShoppingBasket} from 'react-icons/fa'
import {FaIdBadge} from 'react-icons/fa'
import {FaSearch} from 'react-icons/fa'
import {FaBars} from 'react-icons/fa'
import freshVegi from '../assets/freshVegi.png'   
import mixedFruits from '../assets/mixedFruits.png' 
import fruitsnbiscuits from '../assets/fruitsnbiscuits.png' 


function Header(){
return (
    <>
    <div className='header_contianer'>
    <div className='header_contianer-L'>
    <div className='header_contianer-L__contents'>
    <div className='header_contianer-L__name-nav'>
    <div className='header_contianer-L__name'>Fresh <span>e</span>ats</div>
    <div className='header_contianer-L__nav'>
    <nav>
    <ul>
    <li>Home</li>
    <li>Products</li>
    <li>Contact us</li>
    </ul>
    </nav>
    </div>
    </div>
    <div className='header_contianer-R__searchMob'> <input type='text' placeholder='search...' /><FaSearch className='searchIconMob' /></div>
    <div className='header_contianer-R__search-mobile'><input type='text' placeholder='search'  className='header_contianer-R__search-mobileinput' /><FaSearch className='searchIcon-mobile' /></div>
    <div className='header_contianer-L__title'><span>Organic</span><br/><span>Healthy Fresh </span><br/><span>Food For You.</span><br/></div>
    <div className='header_contianer-L__subtittle'><p>Lorem ipisum Lorem ipisum Lorem ipisum Lorem ipisum Lorem ipisum Lorem ipisumLorem ipisum Lorem</p></div>
    <div className='header_contianer-L__button'><button>Order now</button></div>
    </div>
    </div>
    <div className='header_contianer-R'>
    <div className='header_contianer-R-wrap'>
    <div className='header_contianer-R__search'> <input type='text' placeholder='search...' /><FaSearch className='searchIcon' /></div>
    <div className='header_contianer-R__shopingcart'><FaShoppingBasket className='ShoppingBasket' /><FaBars className='bars'/></div>
    </div>
    </div>
    <div className='header_contianer-R__img'><img src = {fruitsnbiscuits} lazyloading = 'true' className='header_contianer-R__img-fruits'/></div>
    </div>
 
    </>
)
}

export default Header;